import { styled, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

const UserId: React.FC = () => {
    const { t } = useTranslation();

    return (
        <Container>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                <Typography color="primary" fontWeight="700" style={{ marginTop: 20, marginBottom: 10, fontSize: 20 }}>
                    {t("user_id")}
                </Typography>
            </div>
            <Typography textAlign="center">{localStorage.getItem("userId")?.slice(0, 5)}</Typography>
        </Container>
    );
};

export default UserId;
export const Container = styled("div")`
    padding: 0px;
`;
